export default {
  name: 'editableCell',
  props: {
    text: {},
    align: String
  },
  data: function data() {
    return {
      form: {
        value: this.text
      },
      textAlign: this.align,
      editable: false,
      rules: {
        value: [{
          required: true,
          message: '请输入内容',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handleChange: function handleChange(e) {
      var value = e.target.value;
      this.form.value = value;
    },
    check: function check() {
      var _this = this;
      var self = this;
      console.log(self.$refs.form1);
      self.$refs.form1.validate(function (valid) {
        if (valid) {
          //验证通过组装数据
          _this.editable = false;
          _this.$emit('change', _this.form.value);
        } else {
          return false;
        }
      });
    },
    edit: function edit() {
      this.editable = true;
    }
  }
};